import {
    useReactTable,
    getCoreRowModel,
    getSortedRowModel,
    getFilteredRowModel,
    flexRender,
    getFacetedRowModel,
    getFacetedUniqueValues,
} from "@tanstack/react-table";
import { useState } from "react";
import FilterDropdown from "./filterDropDown";
import { Tooltip } from "antd";
import resumeicon from "../assets/images/resume.svg";
import disable_detailed_personality from "../assets/images/detailed_personality_disable.svg";
import summaryIco from '../assets/images/candidat_summary.svg'
import disbaleSummary from '../assets/images/candidate-summary_disable.svg'
import detailedPersonalityIcon from '../assets/images/detailed-persoonality.svg'
import cardtext from "../assets/images/card-text.svg";


const makeColumnData = (accesskey, title) => {

    return {
        accessorKey: accesskey,
        header: ({ column }) => (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                {title}

                {/* Sort Icon */}
                <span
                    style={{ cursor: "pointer" }}
                    onClick={column.getToggleSortingHandler()}
                >
                    {column.getIsSorted() === "asc" && "⬆️"}
                    {column.getIsSorted() === "desc" && "⬇️"}
                    {!column.getIsSorted() && "↕️"}
                </span>

                {/* Filter Icon */}
                <FilterDropdown column={column} />
            </div>
        ),
        cell: info => {
            let text = info.getValue()

            text = text ? text?.length > 12 ? text?.slice(0, 12) + '...' : text : '';

            return <Tooltip title={text}> <span>{text}</span></Tooltip>

        },
        filterFn: (row, columnId, filterValue) => {
            if (!filterValue?.length) return true;
            return filterValue.includes(row.getValue(columnId));
        },
    }

}


const personalityDisplay = (accesskey, title, secondDisplayKey) => {

    return {
        accessorKey: accesskey,
        header: ({ column }) => (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                {title}

                {/* Sort Icon */}
                <span
                    style={{ cursor: "pointer" }}
                    onClick={column.getToggleSortingHandler()}
                >
                    {column.getIsSorted() === "asc" && "⬆️"}
                    {column.getIsSorted() === "desc" && "⬇️"}
                    {!column.getIsSorted() && "↕️"}
                </span>

                {/* Filter Icon */}
                <FilterDropdown column={column} />
            </div>
        ),
        cell: info => {
            let text = info.getValue()
            const rowData = info.row.original;

            text = text ? text + ' ' + `(${rowData[secondDisplayKey]})` : "";


            return <Tooltip title={text}> <span>{text}</span></Tooltip>

        },
        filterFn: (row, columnId, filterValue) => {
            if (!filterValue?.length) return true;
            return filterValue.includes(row.getValue(columnId));
        },
    }

}

const arrayDisplay = (accesskey, title) => {
    return {
        accessorKey: accesskey,
        header: ({ column }) => (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                {title}

                {/* Sort Icon */}
                <span
                    style={{ cursor: "pointer" }}
                    onClick={column.getToggleSortingHandler()}
                >
                    {column.getIsSorted() === "asc" && "⬆️"}
                    {column.getIsSorted() === "desc" && "⬇️"}
                    {!column.getIsSorted() && "↕️"}
                </span>

                {/* Filter Icon */}
                <FilterDropdown column={column} />
            </div>
        ),
        cell: info => {
            let text = info.getValue()
            const rowData = info.row.original;


            const result = text.map(tag => tag.status);


            return <Tooltip title={result?.join(",")}> <span>{text[0]?.status}{result?.length > 1 ? " " + result.length - 1 + "+" : ""}</span></Tooltip>

        },
        filterFn: (row, columnId, filterValue) => {
            if (!filterValue?.length) return true;
            return filterValue.includes(row.getValue(columnId));
        },
    }


}

const reportsSection = (accesskey, title) => {

    return {
        accessorKey: accesskey,
        header: ({ column }) => (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                {title}
            </div>
        ),
        cell: info => {
            let text = info.getValue()

            const record = info.row.original;




            return <div className="d-flex gap-1">



                <Tooltip
                    style={{ fontSize: "10px", background: "#fff" }}
                    title={"Resume"}
                >
                    <img
                        src={resumeicon}
                        style={{
                            width: '12px',
                            height: '12px',
                            cursor: 'pointer'

                        }}
                        onClick={(e) => {
                            if (!record.resume) return
                            e.stopPropagation();
                            window.open(
                                record.resume,
                                "_blank"
                            );
                            // window.open(record?.candidatePersonalityReportFile);
                        }}
                    />
                </Tooltip>

                <Tooltip
                    style={{ fontSize: "10px", background: "#fff" }}
                    title={record?.candidatePersonalityReportFile ? "View Detailed Personality" : "Create Detailed Personality"}
                >
                    <img
                        src={record?.candidatePersonalityReportFile ? detailedPersonalityIcon : disable_detailed_personality}
                        style={{
                            width: '12px',
                            height: '12px',
                            cursor: 'pointer'

                        }}
                        onClick={(e) => {

                            if (!record?.candidatePersonalityReportFile) {

                                // setIsShowCandidateReport(true)
                                // setUserId(record?.userId);
                                // setUserName(record?.name);

                                return

                            }

                            e.stopPropagation();
                            // window.open(
                            //     `/personalityReport/${code}/${record?.userId}`,
                            //     "_blank"
                            // );
                            // window.open(record?.candidatePersonalityReportFile);
                        }}
                    />
                </Tooltip>
                <Tooltip
                    style={{ fontSize: "10px", background: "#fff" }}
                    title={record?.aiSummary ? "View Candidate Summary" : "Create Candidate Summary"}
                >
                    <img
                        src={record?.aiSummary ? summaryIco : disbaleSummary}
                        style={{
                            width: '12px',
                            height: '12px',
                            cursor: 'pointer'

                        }}
                        onClick={(e) => {

                            // handleSummary(record?.userId)
                            // window.open(record?.candidatePersonalityReportFile);
                        }}
                    />
                </Tooltip>

                {
                    record?.haveNote &&


                    <Tooltip
                        style={{ fontSize: "10px", background: "#fff" }}
                        title={"Notes"}
                    >
                        <img
                            src={cardtext}
                            onClick={(e) => {
                                // e.stopPropagation()
                                // setUserId(record?.userId);
                                // setUserName(record?.name);
                                // handleGetNotes(record?.id, record?.userId)
                            }}
                            style={{ width: "12px", backgroundColor: "white", cursor: 'pointer', color: "black" }}
                        />
                    </Tooltip>
                }


            </div>

        },

    }

}


const columns = [
    makeColumnData('name', "Name"),
    makeColumnData('phoneNumber', 'No'),
    makeColumnData('emailId', "Email"),
    makeColumnData('educationLevel', 'Edu.Level'),
    makeColumnData('feildOfEducation', 'Edu.Area'),
    makeColumnData('experience', 'Exp.Year'),
    makeColumnData('roleName', 'Current Title'),
    makeColumnData('currentIndustry', 'Current Industry'),
    makeColumnData('departmentName', 'Department'),
    makeColumnData('currentLocation', 'Location'),
    makeColumnData('expectedCTC', 'Salary Exp.'),

    makeColumnData('availableDate', 'Avail By'),
    makeColumnData('noticePeriodBuyoption', 'Custom Q.1'),
    makeColumnData('currentCompany', 'Custom Q.2'),
    makeColumnData('currentCompany', 'Custom Q.3'),
    makeColumnData('currentCompany', 'Custom Q.4'),
    makeColumnData('currentCompany', 'Custom Q.5'),
    makeColumnData('currentCompany', 'Custom Q.6'),
    personalityDisplay('primaryName', 'Pr. Personality', 'primaryMatch'),
    personalityDisplay('secondaryName', 'Sec. Personality', 'secondaryMatch'),
    makeColumnData('personalityMatch', 'Personality'),
    personalityDisplay('profile_1', 'Graph I (M)', 'preD_M'),
    personalityDisplay('profile_2', 'Graph II (L)', 'preD_L'),
    personalityDisplay('profile_3', 'Graph III (C)', 'preD_D'),
    makeColumnData('dateOfCompletion', 'App. Date'),
    makeColumnData('quizScore', 'Quiz Score'),
    reportsSection('reports', 'Reports'),
    arrayDisplay('tags', 'Assigned Tags'),
];


export default function TanStackTable({ data }) {
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);

    const table = useReactTable({
        data,
        columns,
        state: {
            sorting,
            columnFilters,
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),

        getFacetedRowModel: getFacetedRowModel(),
        getFacetedUniqueValues: getFacetedUniqueValues(),
    });

    return (
        <div style={{ width: "98vw", height: '70vh', overflowX: "auto" }}>

            <table border="1" cellPadding="8" style={{
                width: '60vw',
                overflow: 'scroll'
            }}>
                <thead>
                    {table.getHeaderGroups().map(hg => (
                        <tr key={hg.id}>
                            {hg.headers.map(header => (
                                <th key={header.id}>
                                    {flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                <tbody>
                    {table.getRowModel().rows.map(row => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => (
                                <td key={cell.id}>
                                    {flexRender(
                                        cell.column.columnDef.cell,
                                        cell.getContext()
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
